const ORDER_PREFIX = /^(\d+)[_\s-]+/

const getOrderPrefix = value => {
  const match = String(value || '').trim().match(ORDER_PREFIX)
  return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER
}

export function compareOrderedNames(codeA, codeB, labelA = codeA, labelB = codeB) {
  const orderA = getOrderPrefix(codeA)
  const orderB = getOrderPrefix(codeB)
  if (orderA !== orderB) return orderA - orderB
  return String(labelA || '').localeCompare(String(labelB || ''))
}

export function compareTopicsWithinArea(_areaLabel, topicALabel, topicBLabel, topicACode = topicALabel, topicBCode = topicBLabel) {
  return compareOrderedNames(topicACode, topicBCode, topicALabel, topicBLabel)
}
